import React from 'react';

const Search = props => (
  <svg width="25" height="25" viewBox="0 0 30 30" {...props}>
    <path d="M28.997 27.797l-6.926-6.926a12.103 12.103 0 0 0 2.983-7.969C25.054 6.197 19.6.75 12.902.75 6.197.75.75 6.204.75 12.902c0 6.698 5.454 12.152 12.152 12.152 3.046 0 5.833-1.125 7.969-2.983l6.926 6.926a.859.859 0 0 0 .6.253.854.854 0 0 0 .6-1.453zM3.597 12.86c0-5.11 4.156-9.26 9.26-9.26 5.108 0 9.26 4.157 9.26 9.26s-4.152 9.265-9.26 9.265c-5.104 0-9.26-4.157-9.26-9.265z" />
  </svg>
);

export default Search;
